<app-header></app-header>
<section id="equipo-int" class="bg-grey reset-section-pad2">

    <div class="container" data-aos="fade-right" data-aos-duration="1500">

          <div class="row" >
             <div class="col-12 offset-0 col-sm-12 offset-0 col-md-12 offset-0 col-lg-6 offset-lg-3 head-tit">
                   <h1>Error 404 :(</h1>
                  <h2>Lo sentimos, la página que buscas no está en la web.</h2>
                  <p>Esto puede ocurrir por dos motivos:</p>
                   <p>La dirección de Internet que has tecleado es errónea</p>
                   <p>La página ha sido eliminada o cambiada de lugar</p>
                  <a class="btn btn-rco" routerLink="/"><p>Volver a inicio </p></a>
             </div>   
         </div>


     </div><!-- fin container-->

</section>

<app-footer-main></app-footer-main>

